module.exports = __webpack_public_path__ + "static/media/alertIconOriginal.92d027c3.svg";